import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ROUTER_BACKOFFICE } from 'app/AppRouter';
import { RootState } from 'app/AppStore';
import {
  fetchSavePromotionRequestSaga,
  getCreatePromotion,
  getPublishedStatus,
  resetLoadedPromotions,
  setCreatePromotion,
} from 'domains/promotion/Promotion.store';
import CopyPromotion from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CopyPromotion';
import CreatePromotion from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/CreatePromotion';
import EditPromotion from 'pages/BackOfficePage/BackOfficeCategories/Promotion/EditPromotion';
import { SModal } from 'pages/BackOfficePage/BackOfficeCategories/Promotion/PromotionModal/PromotionModal.styled';
import { PROMOTION } from 'pages/BackOfficePage/BackOfficePage.type';

export interface ModalTypeProps {
  modalType?: 'create' | 'edit' | 'copy';
  urlParams?: URLSearchParams;
}

const PromotionModal = ({ modalType, urlParams }: ModalTypeProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const promotion = useSelector(getCreatePromotion);
  const publishedStatus = useSelector((state: RootState) => getPublishedStatus(state, promotion.promotionId));

  const handleCancel = () => {
    history.push(`${ROUTER_BACKOFFICE}/${PROMOTION}?${urlParams}`);
    if (!publishedStatus && modalType !== 'edit') {
      dispatch(setCreatePromotion({ ...promotion, isSaved: true }));
      dispatch(fetchSavePromotionRequestSaga({ shouldPublish: false }));
    }
    dispatch(resetLoadedPromotions('PLANNED'));
    dispatch(resetLoadedPromotions('PUBLISHED'));
    dispatch(resetLoadedPromotions('SAVED'));
  };

  const renderByModalType = () => {
    switch (modalType) {
      case 'create':
        return <CreatePromotion handleCancel={handleCancel} />;
      case 'edit':
        return <EditPromotion handleCancel={handleCancel} />;
      case 'copy':
        return <CopyPromotion handleCancel={handleCancel} />;
      default:
        return <></>;
    }
  };

  return (
    <SModal
      open={Boolean(modalType)}
      footer={<></>}
      getContainer={document.getElementById('promotion_main_page') ?? document.body}
      zIndex={900}
      marginX={0}
      closable={false}
    >
      {renderByModalType()}
    </SModal>
  );
};

export default PromotionModal;
